import { registerOptionConflictWarnings } from "@/rules/events/body/option-conflict-warnings";
import { registerTraySlideCuttingBoard } from "@/rules/plugins/body/tray-slide-cutting-board";
import { registerAutoSelectSingleOption } from "@/rules/plugins/body/auto-select-single-option";
import { registerQuoteSummaryTableUpdate } from "@/rules/plugins/quote-summary/table-update";
import { registerPreselectDependentFromDropdown } from "@/rules/plugins/body/preselect-dependent-from-dropdown";
import { registerApplyDefaultDependentOption } from "@/rules/plugins/body/apply-default-dependent-option";

const EVENTS: Array<() => () => void> = [registerOptionConflictWarnings];

const PLUGINS: Array<() => () => void> = [
  registerTraySlideCuttingBoard,
  registerQuoteSummaryTableUpdate,
  registerAutoSelectSingleOption,
  registerPreselectDependentFromDropdown,
  registerApplyDefaultDependentOption,
];

export const OBSERVERS: Array<() => null> = [];

export function registerAll(): () => void {
  const unregisterFns = [...EVENTS, ...PLUGINS].map((register) => register());
  return () => unregisterFns.forEach((unregister) => unregister());
}
